

export const API_URL = "/api/Carousel";

export const CAROUSEL_ITEMS_BY_DEVICE = {
    "1": { "Desktop": 1, "Laptop": 1, "Tablet": 1, "Mobile": 1 },
    "2": { "Desktop": 2, "Laptop": 2, "Tablet": 2, "Mobile": 1 },
    "3": { "Desktop": 3, "Laptop": 2, "Tablet": 2, "Mobile": 1 },
    "4": { "Desktop": 4, "Laptop": 3, "Tablet": 2, "Mobile": 1 },
    "5": { "Desktop": 5, "Laptop": 4, "Tablet": 3, "Mobile": 1 },
    "default": { "Desktop": 4, "Laptop": 3, "Tablet": 2, "Mobile": 1 }
};

export const CAROUSEL_TYPES = {
    LINKS: "Links",
    ICONS: "Icons",
    BOXES: "Boxes",
    FLIPPINGS: "Flippings",
    EVENTS: "Events",
    MINI_NEWS: "MiniNews",
    TABS: "Tabs"
}

export const LINKS_VIEW_MODE = {
    image: "Image",
    icon: "Icons"
}